import ShapeEnum from "../../types/enums/ShapeEnum";
export function _getAllPolygonIdsFromData(data) {
    return data.shapes.ids.filter(id => data.shapes.byId[id].type === ShapeEnum.POLYGON);
}
export function _getAllPolygonsFromData(data) {
    return _getAllPolygonIdsFromData(data).map(id => data.shapes.byId[id]);
}
